import { ShieldAlert } from "lucide-react";

export default function ErisimYokPage() {
  return (
    <div
      className="rounded-xl border bg-card p-8 sm:p-12 text-center shadow-[0_1px_0_rgba(14,27,46,0.06),0_10px_30px_rgba(14,27,46,0.06)]"
      data-testid="access-denied-card"
    >
      <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-destructive/10 text-destructive">
        <ShieldAlert className="h-6 w-6" />
      </div>
      <h2 className="font-display text-xl sm:text-2xl font-semibold tracking-tight">
        Erişim Yetkiniz Yok
      </h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground leading-relaxed">
        Bu sayfadaki veriler KVKK kapsamında korunmaktadır ve yalnızca Yönetici
        rolündeki kullanıcılar tarafından görüntülenebilir.
      </p>
    </div>
  );
}
